/**
 * Generates an invoice number based on current date and time
 * Format: YYYYMMDDHHMMSS (year, month, date, hour, minutes, seconds)
 * @param {Date} date - Optional date object. If not provided, uses current date
 * @returns {string} - Invoice number in format YYYYMMDDHHMMSS
 */
export const generateInvoiceNumber = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hour = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}${month}${day}${hour}${minutes}${seconds}`;
};

/**
 * Generates an invoice number with a custom prefix
 * @param {string} prefix - Prefix to add before the date/time string
 * @param {Date} date - Optional date object. If not provided, uses current date
 * @returns {string} - Invoice number with prefix in format PREFIX_YYYYMMDDHHMMSS
 */
export const generateInvoiceNumberWithPrefix = (prefix, date = new Date()) => {
  const timestamp = generateInvoiceNumber(date);
  return `${prefix}_${timestamp}`;
};

/**
 * Generates an invoice number with a suffix (useful for multiple invoices in same second)
 * @param {Date} date - Optional date object. If not provided, uses current date
 * @param {number} suffix - Optional suffix number to append
 * @returns {string} - Invoice number in format YYYYMMDDHHMMSS_SUFFIX
 */
export const generateInvoiceNumberWithSuffix = (date = new Date(), suffix = 1) => {
  const timestamp = generateInvoiceNumber(date);
  return `${timestamp}_${String(suffix).padStart(3, '0')}`;
};
